// extracted by css-extract-rspack-plugin
export default {"similarItems":"_a5d52052","topBarWrapper":"_31ba593c","recentlyViewedWrapper":"_6e5cb334","buyerIncentives":"_d7c98c1e"};